const currencySelectors = Array.from(document.querySelectorAll('[data-header-currency-details]'));

currencySelectors.forEach((selector) => {
  selector.addEventListener('toggle', () => {
    if (!selector.open) return;

    currencySelectors.forEach((otherSelector) => {
      if (otherSelector !== selector) otherSelector.open = false;
    });
  });

  selector.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !selector.open) return;

    selector.open = false;
    selector.querySelector('summary')?.focus();
  });
});

document.addEventListener('click', (event) => {
  currencySelectors.forEach((selector) => {
    if (!selector.contains(event.target)) selector.open = false;
  });
});
